/* Shiok post add to cart upsell, "Nice pick! One last thing." (Boss 2026-10-07).
   Config, prices and stock come from snippets/shiok-upsell.liquid (rendered in layout/theme.liquid).
   Ported from the approved Package Finder popup; the finder now uses this module too, so there is ONE popup.

   Flow: any successful /cart/add of a product from bbq-package (DIY), live-station-bbq-assistant-package (Assist)
   or live-station-bbq-chef (Chef) -> wait until the theme's cart drawer is open -> read /cart.js -> drop what the
   cart already has (tool set, ice, and ANY drink: product type Non-Alcoholic or Alcoholic) -> open the popup on top
   of the drawer. Nothing left to offer = no popup.
   Order of the cards (Boss 2026-10-15): tools, ice, lobster and oysters, then drinks. Lobster = the best seller
   (The Too Good To Be True Live Boston Lobster Bundle), oyster = Salt Works Trio de Claire, both with their variant
   selects, same cards as the /cart popup (shiok-cart-upsell.js). Live Station adds pass the booking gate first; the gate re-submits
   the theme form, so this only ever sees the add that actually reached the cart. */
(function () {
  'use strict';
  if (window.ShiokUpsell) return;
  var cfgEl = document.getElementById('shiokUpsellCfg');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (CFG.cartPage) return;   /* the cart page has its own flow; the theme redirects there instead of opening a drawer */

  var U = {
    tool: { h: 'essential-bbq-tool-set', vid: 45832123875477, per: 20, title: 'Essential BBQ Tool Set (Gas & Electric Grill)' },
    drinks: [
      { h: 'hawaiian-tropical-mocktail', title: 'Hawaiian Tropical Mocktail', v: [[45501965336725, '10 Litres (15-25pax)', 25], [45502022942869, '15 Litres (30-45pax)', 45], [45502022975637, '20 Litres (55-65pax)', 65]] },
      { h: 'rosemary-cranberry-lime-mocktail', title: 'Rosemary Cranberry Lime Mocktail', v: [[45501989617813, '10 Litres (15-25pax)', 25], [45502020845717, '15 Litres (30-45pax)', 45], [45502020878485, '20 Litres (55-65pax)', 65]] }
    ],
    ice: { h: 'ice-cube', title: 'Ice + foam box', small: [44833761427605, '4kg ice + 7-10L foam box'], big: [45297555734677, '8kg ice + 10-15L foam box'] }
  };
  /* lobster and oysters (Boss 2026-10-15). Popup only labels and lines, never written back to the product (lesson 309).
     def = id of the variant shown first: the lobster's best seller (Poached & Cut, no butter, 6 of 17 orders in the last 12 months). */
  var SEA = [
    { h: 'the-boston-lobster-party-pack-4-pcs', title: 'The Too Good To Be True Live Boston Lobster Bundle', sub: '4 lobsters, 400g to 500g each', o: ['Prep style', 'Butter'],
      def: 46760266006677, why: 'Sweet, tender lobster meat. Even better with our smoked garlic, dill lemon or togarashi butter.' },
    { h: 'salt-works-trio-de-claire-sg61-edition-60-pcs-1-caviar', x: ['live-oyster-party-pack'], title: 'Salt Works Trio de Claire', sub: '60 oysters, 3 French Claire varieties', o: ['How you want them', 'Set'],
      def: 47639358111893, why: 'Briny sweet with a clean mineral finish. Rested in French clay beds, best slurped ice cold.' }
  ];
  var UPSUB = {
    chef: 'Your chef team brings the tools, plates and cutlery. Drinks and ice are not included, you can add them below.',
    assist: 'Your BBQ Assistant brings the grill tools, plates and cutlery. Drinks and ice are not included, you can add them below.',
    diy: 'This package is food only. Grill tools, drinks and ice are not included, you can add them below.'
  };
  var DRINK_RX = /^(non-)?alcoholic$|beverage|drink/i;

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var money = function (c) { var n = (Math.round(c) / 100).toFixed(2).split('.'); return '$' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1]; };
  var img = function (u, w) { if (!u) return ''; return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + (w || 240); };

  /* service of a product, same rule as the finder data: a variant title naming DIY / Assistant / Chef wins, else the
     collections it sits in (both live station collections = chef) */
  function kindOf(handle, vtitle) {
    var t = String(vtitle || '').toLowerCase();
    var inD = !!CFG.h[handle], inA = !!CFG.a[handle], inC = !!CFG.c[handle];
    if (!inD && !inA && !inC) return null;
    if (/\bdiy\b/.test(t)) return 'diy';
    if (/assistant|助理/.test(t)) return 'assist';   /* /zh titles: 烧烤助理, 厨师 (Boss 2026-10-08) */
    if (/\bchef\b|厨师/.test(t)) return 'chef';
    if (inC) return 'chef';
    if (inA) return 'assist';
    return 'diy';
  }
  /* guests from the pax range in the variant or product title (same reading as _finder-data.py pax_range) */
  function paxOf(vtitle, ptitle) {
    var ts = [vtitle, ptitle];
    for (var i = 0; i < ts.length; i++) {
      var t = String(ts[i] || '').toLowerCase().replace(/–/g, '-');
      var m = t.match(/(\d+)\s*-\s*(\d+)\s*(?:pax|人)/);   /* /zh titles say 人 instead of pax */
      if (m) return [+m[1], +m[2]];
      m = t.match(/(\d+)\s*(?:pax|人)/);
      if (m) return [+m[1], +m[1]];
    }
    return null;
  }

  function items(kind, n, label) {
    var LV = CFG.up || {}, out = [];
    function live(h, vid) { var p = LV[h]; if (!p) return null; var x = p.v[vid]; return (x && x[1]) ? { price: x[0], img: p.img } : null; }
    if (kind === 'diy') {
      var t = live(U.tool.h, U.tool.vid);
      if (t) out.push({ h: U.tool.h, sec: 'To grill and serve', vid: U.tool.vid, title: U.tool.title, sub: '', price: t.price, q: Math.max(1, Math.ceil(n / U.tool.per)), img: t.img,
        why: 'Tongs, trays, plates, cutlery, cups, kitchen towel and trash bags for 20 guests. Made for gas and electric grills.' });
    }
    var b = n > 10 ? U.ice.big : U.ice.small, I = live(U.ice.h, b[0]);   /* ice for every service, chef too */
    if (I) out.push({ h: U.ice.h, sec: 'Keep it cold', vid: b[0], title: U.ice.title, sub: b[1], price: I.price, q: n > 10 ? Math.ceil(n / 20) : 1, img: I.img,
      why: kind === 'diy' ? 'Keeps the drinks and raw food cold.' : (kind === 'assist' ? 'Ice for your drinks. The ice we deliver only keeps the food cold on the way.' : 'Keeps the drinks cold through the party.') });
    (CFG.sf || []).forEach(function (o) {   /* lobster and oysters, offered to every package (Boss 2026-10-15) */
      var C = SEA.filter(function (x) { return x.h === o.h; })[0]; if (!C) return;
      var av = o.v.filter(function (x) { return x[4]; }); if (!av.length) return;
      var d = av.filter(function (x) { return x[0] === C.def; })[0] || av[0];   /* by variant id, option names are translated on /zh */
      out.push({ h: o.h, x: C.x || [], sec: 'A taste of the sea', title: C.title, sub: C.sub, why: C.why, labels: C.o, ov: o.v, cur: d, vid: d[0], price: d[3], q: 1, img: o.img });
    });
    U.drinks.forEach(function (d, i) {
      var v = d.v.filter(function (x) { return n <= x[2]; })[0] || d.v[d.v.length - 1], q = n > 65 ? Math.ceil(n / 65) : 1, L1 = live(d.h, v[0]);
      if (L1) out.push({ h: d.h, grp: 'drinks', sec: 'Drinks (no alcohol)', vid: v[0], title: d.title, sub: v[1], price: L1.price, q: q, img: L1.img,
        why: i === 0 ? 'Our best-selling drink, sized for ' + label + '.' : 'Fresh and tangy, our second favourite.' });
    });
    return out;
  }

  function refreshDrawer() {
    /* the theme's own drawer refresh (component-product-form.js) */
    return fetch('?section_id=helper-cart').then(function (r) { return r.text(); }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html');
      var f = doc.getElementById('AjaxCartForm'), s = doc.getElementById('AjaxCartSubtotal');
      var F = document.getElementById('AjaxCartForm'), S = document.getElementById('AjaxCartSubtotal');
      if (f && F) { F.innerHTML = f.innerHTML; if (typeof F.ajaxifyCartItems === 'function') F.ajaxifyCartItems(); }
      if (s && S) S.innerHTML = s.innerHTML;
      var cc = document.querySelector('#AjaxCartForm [data-cart-count]'), ct = document.querySelector('#AjaxCartForm [data-cart-total]');
      if (cc) document.querySelectorAll('[data-header-cart-count]').forEach(function (e) { e.textContent = cc.textContent; });
      if (ct) document.querySelectorAll('[data-header-cart-total]').forEach(function (e) { e.textContent = ct.textContent; });
    });
  }
  var origFetch = window.fetch;
  function addLines(lines) {
    return origFetch.call(window, '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Shiok-Upsell': '1' }, body: JSON.stringify({ items: lines }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { return refreshDrawer().then(function () { return j; }, function () { return j; }); });
  }

  /* variant selects of the lobster and oyster cards, same two level logic as the /cart popup */
  var uniq = function (a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); };
  function seaOpts(it, i) {
    var av = it.ov.filter(function (x) { return x[4]; }), cur = it.cur;
    var o1 = uniq(av.map(function (x) { return x[1]; })), o2 = uniq(av.filter(function (x) { return x[1] === cur[1]; }).map(function (x) { return x[2]; }));
    var sel = function (n, list, val, lab) {
      if (!list.length || (list.length === 1 && list[0] === null)) return '';
      return '<label' + (list.length < 2 ? ' hidden' : '') + '>' + esc(lab) + '<select data-upopt="' + n + '" data-i="' + i + '">' +
        list.map(function (x) { return '<option' + (x === val ? ' selected' : '') + '>' + esc(x) + '</option>'; }).join('') + '</select></label>';
    };
    return '<div class="pf-ui__opts">' + sel(1, o1, cur[1], it.labels[0]) + sel(2, o2, cur[2], it.labels[1]) + '</div>';
  }
  function seaChange(L, s) {
    var i = +s.dataset.i, it = L[i], c = s.closest('.pf-ui');
    var s1 = c.querySelector('select[data-upopt="1"]'), s2 = c.querySelector('select[data-upopt="2"]');
    if (s.dataset.upopt === '1' && s2) {
      var list = uniq(it.ov.filter(function (x) { return x[1] === s1.value && x[4]; }).map(function (x) { return x[2]; }));
      var keep = list.indexOf(s2.value) >= 0 ? s2.value : list[0];
      s2.innerHTML = list.map(function (x) { return '<option' + (x === keep ? ' selected' : '') + '>' + esc(x) + '</option>'; }).join('');
      s2.parentNode.hidden = list.length < 2;
    }
    var v = it.ov.filter(function (x) { return x[1] === (s1 ? s1.value : null) && x[2] === (s2 ? s2.value : null) && x[4]; })[0] || null;
    it.cur = v; it.vid = v ? v[0] : 0; it.price = v ? v[3] : 0;
    var b = c.querySelector('[data-upadd]'), p = c.querySelector('[data-price]');
    p.textContent = v ? money(v[3]) : 'Sold out';
    if (!b.classList.contains('is-done')) { b.disabled = !v; b.textContent = v ? 'Add' : 'Sold out'; }
  }

  /* GA4 events for the popup tracker (Boss 2026-10-15, Rose builds the Sheet): upsell_popup_shown, upsell_popup_closed,
     upsell_popup_add. Sent to G-Q2S5DM0RB8 only; silent when gtag is missing. upsell_item is the product handle, the
     same on /zh. ST holds the popup now open, so a close or an add always reports the kind it belongs to. */
  var ST = null;
  function ga(name, p) {
    try { if (typeof window.gtag === 'function') { p.send_to = 'G-Q2S5DM0RB8'; window.gtag('event', name, p); } } catch (e) {}
  }
  function close(method) {
    var u = document.getElementById('pfUp'); if (!u) return;
    u.remove();
    if (ST) { ga('upsell_popup_closed', { upsell_kind: ST.kind, close_method: method || 'other', upsell_added_count: ST.added }); ST = null; }
  }
  function open(kind, n, label, cart) {
    close('reopened');
    var L = items(kind, n, label), last = '';
    var have = {}, drinksIn = false;
    ((cart && cart.items) || []).forEach(function (it) { have[it.handle] = true; if (DRINK_RX.test(String(it.product_type || '').trim())) drinksIn = true; });
    if (L.some(function (it) { return it.grp === 'drinks' && have[it.h]; })) drinksIn = true;
    L = L.filter(function (it) { return it.grp === 'drinks' ? !drinksIn : (!have[it.h] && !(it.x || []).some(function (h) { return have[h]; })); });
    if (!L.length) return;   /* the cart already has everything we would offer */
    var html = '<div class="pf-up shiok-up" id="pfUp" role="dialog" aria-modal="true" aria-labelledby="pfUpH"><div class="pf-up__box">' +
      '<button type="button" class="pf-up__x" data-upx aria-label="Close">&times;</button>' +
      '<h2 id="pfUpH">Nice pick! One last thing.</h2><p class="pf-up__sub">' + UPSUB[kind] + '</p>' +
      L.map(function (it, i) {
        var head = it.sec !== last ? '<p class="pf-up__sec">' + it.sec + '</p>' : ''; last = it.sec;
        return head + '<div class="pf-ui"><img src="' + esc(img(it.img, 240)) + '" alt="' + esc(it.title) + '" width="96" height="96" loading="lazy"><div>' +
          '<b>' + (it.q > 1 ? it.q + ' x ' : '') + esc(it.title) + '</b>' + (it.sub ? '<small>' + esc(it.sub) + '</small>' : '') + '<p>' + esc(it.why) + '</p>' +
          (it.ov ? seaOpts(it, i) : '') +
          '<div class="pf-ui__f"><span data-price>' + money(it.price * it.q) + '</span><button type="button" class="pf-ui__add" data-upadd="' + i + '">Add</button></div></div></div>';
      }).join('') +
      '<button type="button" class="pf-btn pf-up__done" data-upx>Done, view my cart</button></div></div>';
    document.body.insertAdjacentHTML('beforeend', html);
    var u = document.getElementById('pfUp');
    var st = ST = { kind: kind, added: 0 };
    ga('upsell_popup_shown', { upsell_kind: kind, upsell_items_offered: L.length });
    u.addEventListener('change', function (e) { var s = e.target.closest('select[data-upopt]'); if (s) seaChange(L, s); });
    u.addEventListener('click', function (e) {
      if (e.target === u) { close('outside'); return; }
      var x = e.target.closest('[data-upx]');
      if (x) { close(x.classList.contains('pf-up__done') ? 'done_button' : 'x_button'); return; }
      var b = e.target.closest('[data-upadd]'); if (!b || b.disabled) return;
      var it = L[+b.dataset.upadd]; if (!it.vid) return;
      b.disabled = true; b.textContent = 'Adding...';
      addLines([{ id: it.vid, quantity: it.q }]).then(function () {
        b.textContent = 'Added'; b.classList.add('is-done');
        st.added++;
        ga('upsell_popup_add', { upsell_kind: kind, upsell_item: it.h });
      })
        .catch(function () { b.disabled = false; b.textContent = 'Try again'; });
    });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && document.getElementById('pfUp')) close('escape'); });

  function drawerOpen() { var d = document.getElementById('site-cart-sidebar'); return !!(d && d.classList.contains('sidebar--opened')); }
  var pending = null;
  function trigger(item) {
    var kind = kindOf(item.handle, item.variant_title);
    if (!kind) return;
    var g = window.__shiokUpsellGuests; window.__shiokUpsellGuests = null;   /* the finder passes the guest count it was given */
    var n, label;
    if (g && g.n) { n = g.n; label = g.label || ('your ' + g.n + ' guests'); }
    else {
      var r = paxOf(item.variant_title, item.product_title), q = Math.max(1, +item.quantity || 1);
      if (r) { n = r[1] * q; label = 'your ' + (r[0] === r[1] ? r[1] * q : (r[0] * q) + '-' + (r[1] * q)) + ' guests'; }
      else { n = 20; label = 'about 20 guests'; }
    }
    if (pending) clearInterval(pending);
    var t0 = Date.now();
    /* on top of the open drawer, never instead of it: wait for the theme to open it (it does after its own refresh) */
    pending = setInterval(function () {
      if (!drawerOpen() && Date.now() - t0 < 4000) return;
      clearInterval(pending); pending = null;
      setTimeout(function () {
        origFetch.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
          .then(function (cart) { open(kind, n, label, cart); }).catch(function () {});
      }, 350);
    }, 100);
  }

  window.fetch = function (input, init) {
    var p = origFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var hdr = init && init.headers, self = hdr && (hdr['X-Shiok-Upsell'] || (typeof hdr.get === 'function' && hdr.get('X-Shiok-Upsell')));
      if (!self && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (res) {
          if (!res.ok) return;
          res.clone().json().then(function (j) {
            var list = j && j.items ? j.items : (j && j.handle ? [j] : []);
            for (var i = 0; i < list.length; i++) { if (kindOf(list[i].handle, list[i].variant_title)) { trigger(list[i]); break; } }
          }).catch(function () {});
        }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };

  window.ShiokUpsell = { open: open, kindOf: kindOf, paxOf: paxOf, items: items };   /* QA hook */
})();
